import * as c from "react";
const e = (a) => /* @__PURE__ */ c.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...a
  },
  /* @__PURE__ */ c.createElement(
    "path",
    {
      d: "M18.875 10.094H17.59c-.887 0-1.606.719-1.606 1.606v7.708c0 .887.72 1.606 1.606 1.606h1.285c.887 0 1.606-.72 1.606-1.606V11.7c0-.887-.72-1.606-1.606-1.606zM6.027 15.232H4.743c-.887 0-1.606.72-1.606 1.606v2.57c0 .887.719 1.606 1.606 1.606h1.284c.887 0 1.606-.72 1.606-1.606v-2.57c0-.887-.719-1.606-1.606-1.606zM12.451 12.662h-1.285c-.886 0-1.605.72-1.605 1.606v5.139c0 .887.719 1.606 1.605 1.606h1.285c.887 0 1.606-.72 1.606-1.606v-5.139c0-.887-.719-1.606-1.606-1.606zM19.864 4.094a.912.912 0 00-.694-.5l-3.16-.566a.95.95 0 00-.938.385.937.937 0 00-.09 1.002l.45.861L3.51 11.378a.976.976 0 00-.032 1.697c.165.097.355.141.545.128a.925.925 0 00.437-.116L16.305 7.01l.437.848a.976.976 0 00.86.527.938.938 0 00.861-.54l1.414-2.89a.964.964 0 00-.013-.86z",
      fill: "#333"
    }
  )
), l = e;
export {
  l as default
};
